import { createClient } from '@supabase/supabase-js';

// TODO: Replace these placeholders with your actual Supabase project URL and anon/public key
const SUPABASE_URL = 'https://withtsrwninwxziccsqx.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndpdGh0c3J3bmlud3h6aWNjc3F4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk5NzY3MzAsImV4cCI6MjA2NTU1MjczMH0.Z_YWWuZjTsIdr0mKeBX-H8orziUvy5x2L17aW79GoFI';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY); 